import styled from "styled-components";

export const ToggleSwitchStyles = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  .toggleTrack {
    position: relative;
    width: 36px;
    height: 20px;
    border-radius: ${({ theme }) => theme.radius.rounded};
    background: ${({ $active, theme }) =>
      $active ? theme.colors.accent[500] : theme.colors.primary[200]};
    transition: background 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    outline: none;

    &::after {
      content: "";
      position: absolute;
      top: 2px;
      left: 2px;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: ${({ theme }) => theme.colors.semantic.container.white};
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
      transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      transform: translateX(${({ $active }) => ($active ? "16px" : "0")});
    }

    &:focus-visible {
      box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.25);
    }
  }
`;
